import Ax from './axios';
import config from './config';

const API = config.BASE_API;

// 文档 http://wiki.cheyaoshicorp.com/pages/viewpage.action?pageId=33953056

export function getCityList() {
  return Ax.get(`${API}/common/cityList`);
}

export function getEvCityList() {
  return Ax.get(`${API}/common/evCityList`);
}

export function getOrderList() {
  return Ax.get(`${API}/report/order`);
}



// WEBPACK FOOTER //
// ./src/api/common.js